module.exports = __webpack_public_path__ + "static/newag-09391118118fcf92b6b1d691b1aceec3.png";